export const SOCKET_EVENTS = {
  CONNECT: "connect",
  DISCONNECT: "disconnect",
  ATTENDANT_JOIN_ROOM: "attendantJoinRoom",
  ATTENDANT_JOIN_CONVERSATION_ROOM: "attendantJoinConversationRoom",
  PENDING_CONVERSATION: "pendingConversation",
  TAKEN_CONVERSATION: "takenCoversation",
  ATTENDANT_SENT_MESSAGE: "attendantSentMessage",
  USER_SENT_MESSAGE: "userSentMessage",
  ATTENDANT_MESSAGE: "attendantMessage",
  CONVERSATION_CLOSED: "conversationClosed",
};
